import BaseService from './baseService'; 

export class ConfirmAlertService extends BaseService {
    constructor(){
        const baseUrl = "/sr/confirm/";
        super(baseUrl);
    }
    
} 